// extracted by mini-css-extract-plugin
export var numpadContainer = "_mi-1";
export var phoneButton = "_mi-0";